import { addImposterToUrl } from 'Utils';
import { api } from './axios';

export interface IDocument {
  id: number;
  documentNumber: string;
  caseNumber: string;
  fileDate?: Date;
  subjectId: number;
  subjectName: string;
  createDate: Date;
  intRequestNumber: string;
  documentName: string;
  fileContentBase64: string;
}

export interface IFile {
  id: number;

  fileContentBase64: string;
  documentName?: string;
}

const baseURL = '/Document';

const recognitionFormCustomCode = 37;

export const getDocumentsByFileNumber = async () => {
  const documents = await api.get<IDocument[]>(
    addImposterToUrl(
      `${baseURL}/metadata/?SubjectCustomCodes=${recognitionFormCustomCode}`,
      false
    )
  );
  if (documents.data) {
    return documents.data;
  }
};

export const getDocuments = async () => {
  const documentsResponse = await api.get<IDocument[]>(
    addImposterToUrl(`${baseURL}/metadata`, true)
  );

  if (documentsResponse) {
    return documentsResponse.data;
  }

  return [];
};

export const getFile = async (fileId: number) => {
  const res = await api.get<IFile>(
    addImposterToUrl(`${baseURL}/${fileId}`, true)
  );
  if (res.data) return res.data;
};
